import { useTheme } from "@mui/material";
import useTab from "../../../../hooks/useTab";
import { ItemContentContainer, ItemWrapper } from "../../../../style";
import TitleWrapper from "../../../TitleWrapper";
import CustomCharts from "./components/Charts";
import { VisualizationOutput } from "./types";

type Props = {
  output: VisualizationOutput;
  index: number;
  isClosed: boolean;
  handleCollapse: (index: number) => () => void;
};

const VisualizationBlock = ({
  output,
  index,
  isClosed,
  handleCollapse,
}: Props) => {
  const { palette } = useTheme();

  const { animationStyles } = useTab({ isClosed });

  return (
    <ItemWrapper>
      <TitleWrapper
        title="Visualization"
        handleCollapse={handleCollapse}
        index={index}
        animationStyles={animationStyles}
      />
      <ItemContentContainer sx={animationStyles.displayContainer}>
        <CustomCharts output={output} />
      </ItemContentContainer>
    </ItemWrapper>
  );
};

export default VisualizationBlock;
